<template>
  <div id="activities">
    <div class="card custom-card scroll-activities">
      <button
        v-if="hasAddActivityButton"
        @click="showModalAddActivityFun"
        type="button"
        class="add-activity ml-auto btn btn-success text-nowrap"
      >
        Add Activity
      </button>

      <h6 class="aside-title">Activities</h6>
      <ul class="list-group activities-media" @scroll="onScroll">
        <ManagerActivityItemNew
          v-for="activity in activities"
          :key="activity.activity_id"
          :activity="activity"
          @removed-activity="onRemoveActivity"
        />
        <!--     <ManagerActivityItem
          v-for="activity in activities"
          :key="activity.activity_id"
          :activity="activity"
          :removeEmployerName="removeEmployerName"
          @removed-activity="onRemoveActivity"
        /> -->
      </ul>

      <ErrorList class="no-data-message" v-show="activities.length <= 0" name="noActivities" />
    </div>

    <!-- Add Activity -->
    <!--  <CustomMainModal
      modalSize="modal-xs"
      @close="showModalAddActivity = false"
      v-show="showModalAddActivity"
    >
      <template v-slot:header>
        <h5>Add Activity</h5>
      </template>
      <div class="modal-body add-act">
        <div class="form-group m-label-left mb-4">
          <v-select
            id="job-select"
            v-model="selectedJobForActivity"
            label="job"
            :options="getCandidatePipelines"
            :reduce="(job) => job"
          >
            <template slot="option" slot-scope="option">
              {{ option.job }},
              {{ option.location.city }}
            </template>
            <template slot="selected-option" slot-scope="option">
              {{ option.hasOwnProperty('job') ? `${option.job},` : null }}
              {{ option.hasOwnProperty('location') ? option.location.city : null }}
            </template>
          </v-select>

          <label id="qualification">Select job</label>
        </div>

        <div class="form-group m-label-left">
          <textarea v-model="message" class="form-control" rows="8" id="comment"></textarea>
          <label for="comment">Comment</label>
        </div>

        <div class="modal-footer d-flex justify-content-center">
          <button
            v-if="!disabledButton"
            @click="onAddActivity"
            type="button"
            class="btn btn-primary"
          >
            Save and close
          </button>
          <button v-else disabled type="button" class="btn btn-primary">Save and close</button>
          <button
            type="button"
            class="btn btn-secondary mr-3"
            data-dismiss="modal"
            @click="onCloseActivityModal"
          >
            Cancel
          </button>
        </div>
      </div>
    </CustomMainModal> -->
    <!-- End Add Activity -->
  </div>
</template>

<script>
import ManagerActivityItem from './ManagerActivityItem.vue';
import ManagerActivityItemNew from './ManagerActivityItemNew.vue';
import CustomMainModal from '../../Modals/CustomMainModal';
import ErrorList from '@/components/common/errorsList';

/* import { stagesMixin } from '../../../mixins/stagesMixin';
import { qualificationMixin } from '../../../mixins/qualificationMixin'; */

import { mapActions, mapGetters } from 'vuex';

export default {
  components: { CustomMainModal, ErrorList, ManagerActivityItem, ManagerActivityItemNew },
  /*  mixins: [stagesMixin, qualificationMixin], */
  props: {
    height: {
      type: String,
      default: '800px',
    },
    activities: {
      type: Array,
      default: () => [],
    },
    hasAddActivityButton: {
      type: Boolean,
      default: false,
    },
    pipelines: {
      type: Array,
      default: () => [],
    },
    removeEmployerName: {
      type: Boolean,
    },
  },
  data: () => ({
    showModalAddActivity: false,
    selectedJobForActivity: {},
    message: '',
    activityComment: '',
    activityForUpdate: {},
    jobOptions: [],
    disabledButton: false,
  }),
  methods: {
    ...mapActions('managerStoreModule', ['retrieveManagerUserProfile']),
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight) {
        this.$emit('getActivities');
      }
    },
    onCloseActivityModal() {
      this.showModal = false;
      this.activityForUpdate = {};
      this.activityComment = '';
    },
    /* getCityName() {
      if (this.activityForUpdate['job-address']) {
        if (this.activityForUpdate['job-address'].hasOwnProperty('city_name')) {
          return this.activityForUpdate['job-address'].city_name;
        }
      }

      return 'N/A';
    }, */

    showModalAddActivityFun() {
      this.showModalAddActivity = true;
      this.disabledButton = false;
    },
    onRemoveActivity() {
      this.$emit('reloadActivities');
    },
    /*  onRemoveActivity(activity) {
      console.log(activity.activity_id);

      this.removeActivity({ activityID: activity.activity_id }).then(() => {
        this.onCloseActivityModal();

        this.$refs.closeModalBtn[0].click();

        this.$emit('removed-activity');
      });
    }, */
    onAddActivity() {
      if (!this.selectedJobForActivity) {
        this.selectedJobForActivity = {};
      }
      if (this.message.length > 0) {
        this.disabledButton = true;
        this.addActivity({
          job_id: this.selectedJobForActivity.job_id,
          candidate_id: this.$route.params.candidate_id,
          comment: this.message,
          stage: this.selectedJobForActivity.stage,
          qualification: this.selectedJobForActivity.qualification,
        })
          .then(() => {
            this.showModalAddActivity = false;
            this.disabledButton = false;
            this.activityComment = '';
            this.message = '';
            this.$emit('added-new-activity');
          })
          .catch(() => {
            this.disabledButton = false;
          });
      }
    },
    /* setActivityForUpdate(activity) {
      this.showModal = true;
      this.activityForUpdate = activity;
      this.activityComment = activity.comments;
    }, */
  },
  computed: {
    ...mapGetters(['getCandidatePipelines', 'getCandidateById']),
  },
  mounted() {
    // this.retrieveManagerUserProfile();
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.card {
  position: relative;
}

.add-activity {
  position: absolute;
  top: 10px;
  right: 10px;
  /* height: 30px; */
  /*  margin: 0 auto; */
  /* padding: 0 5px 0 5px; */
}

#activities {
  margin-bottom: 24px;
  .card {
    margin: 0;
  }
}

.activities-media {
  overflow-y: auto;

  /* figure {
    width: 54px;
    height: 54px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    margin: 0 15px 0 10px;
    img {
      width: 100%;
      height: 100%;
      border-radius: 0;
      object-fit: cover;
    }
  }

  p {
    margin: 0;
    padding: 0;
  }
  .activities-body {
    width: 100%;
  }

  .activities-date {
    position: absolute;
    display: block;
    white-space: nowrap;
    right: 15px;
    color: #000;
    font-size: 13px;
  } */
}

.scroll-activities {
  overflow: hidden;
}

.candidate-aside .scroll-activities {
  height: 612px !important;
}

.job-aside-activity .scroll-activities {
  height: 755px !important;
}
.employer-aside .scroll-activities {
  height: 805px !important;
}

@media only screen and (max-width: 992px) {
  .card {
    border: none;
    border-radius: 0 !important;
    margin-top: 22px !important;
    h6 {
      display: none;
    }
  }
}

@media only screen and (max-width: 768px) {
  .card {
    border: none;
    border-radius: 0 !important;
    margin-top: 22px !important;
    h6 {
      display: none;
    }
  }
}

@media only screen and (max-width: 576px) {
  .card {
    border-radius: 0;
    margin-top: 12px !important;
    border: none;
    min-height: 100vh !important;
    h6 {
      display: block;
    }
    .activities-media {
      overflow: visible;
      height: auto;
    }
  }
}

@media only screen and (max-width: 1251px) {
  #activities {
    margin-bottom: 24px;
    .card {
      margin: 26px 0 0 0;
      border-bottom-left-radius: 18px;
      border-bottom-right-radius: 18px;
    }
  }
}

@media only screen and (max-width: 992px) {
  .card {
    border: none;
    border-radius: 0 !important;
    margin-top: 22px !important;
    h6 {
      display: none;
    }
  }
}

@media only screen and (max-width: 768px) {
  .card {
    border: none;
    border-radius: 0 !important;
    margin-top: 22px !important;
    h6 {
      display: none;
    }
  }
  .modal-header {
    margin-top: 50px;
  }
}

@media only screen and (max-width: 576px) {
  .card {
    border-radius: 0;
    margin-top: 12px !important;
    border: none;
    h6 {
      display: block;
    }
    .activities-media {
      overflow: visible;
      height: auto;
    }
  }
}
</style>
